module.exports = __webpack_public_path__ + "img/ur_get.b9ee68d.png";